export default {"src":"https://fishbrain.com/_next/static/media/florida.dcb67e29.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};